export class UserEmailPwd {
  email: string;
  password: string;
}
